<template>
  <div class="about-us-page-container">
    <div class="banner-container">
      <div class="title about-us-page-enter">
        <span>关于我们</span>
        <span>About Us</span>
        <span>辰戈科技，做改变的的创造者、推动者</span>
      </div>
    </div>
    <div class="introduce-container">
      <div class="title about-us-page-show">关于辰戈</div>
      <div class="content about-us-page-show">
        <p>
          杭州辰戈科技有限公司是一家富有创变精神和行动力的企业创新服务公司，我们通过模式、制度、技术、工具、设计等方面的创新，帮助企业探索和解决自身的问题，在不同行业和领域给人们的工作和生活带来美好改变。
          辰戈核心团队创立于2017年，公司成立于2019年03月26日。我们为全国多家知名企业客户提供了卓有成效的互联网创新定制服务。在服务中我们将互联网新思维、新技术与客户企业的营销、销售、管理、创新环节深度结合，帮助客户企业有效地提升了企业综合竞争力。
        </p>
        <br /><br />
        <p>期待辰戈助力您一起开启新的企业变革篇章！</p>
      </div>
    </div>
    <contact-us></contact-us>
  </div>
</template>

<script>
import contactUs from "@/components/contactUs";
import scrollReveal from "scrollreveal";
export default {
  components: {
    contactUs,
  },
  data() {
    return {
      scrollReveal: scrollReveal(),
    };
  },
  mounted(){
    this.$nextTick(()=>{
      this.scrollReveal.reveal(".about-us-page-enter", {
        duration: 250,
        delay: 0,
        interval: 0,
        origin: "bottom",
        viewOffset: {
          bottom: 20,
        },
        reset: false,
        mobile: false,
        distance: "50px",
        opacity: 0.0,
        easing: "linear",
        scale: 0.99,
      });
      this.scrollReveal.reveal(".about-us-page-show", {
        duration: 200,
        delay: 0,
        interval: 100,
        origin: "bottom",
        viewOffset: {
          bottom: 100,
        },
        reset: false,
        mobile: false,
        distance: "50px",
        opacity: 0.0,
        easing: "linear",
        scale: 0.99,
      });
    })
  },
};
</script>

<style lang="scss" scoped>
.about-us-page-container {
  width: 100%;
  .banner-container {
    background: url("../../../assets/image/main-background.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    height: 726px;
    display: flex;
    justify-content: center;
    align-items: center;
    .title {
      span {
        display: block;
        font-family: PingFangSC-Semibold;
        font-size: 40px;
        color: #ffffff;
        text-align: center;
      }
      span + span {
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        color: #0057ff;
        text-align: center;
      }
      span + span + span {
        margin-top: 40px;
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
  .introduce-container {
    width: 650px;
    margin: 100px auto 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 40px;
      color: #000000;
      text-align: center;
    }
    .content {
      margin-top: 40px;
      font-family: PingFangSC-Regular;
      font-size: 18px;
      color: #000000;
      text-align: justify;
      line-height: 30px;
      text-indent: 2em;
      p{
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/details/components/aboutUsPage.vue